import getApi from '../../api'

export const deleteAnswerInstance = (id: number) => getApi().delete<void>(`/answer_instances/${id}`)
